export const billingStrings = Object.freeze({
  pageTitle: 'Plan & Billing',
  pageSubtitle: 'Manage your subscription, view invoices, and update your payment method.',

  loadingTitle: 'Plan & Billing',
  loadingSubtitle: 'Loading billing data…',

  currentSubscriptionTitle: 'Current subscription',
  currentSubscriptionPlanLabel: 'Plan',
  currentSubscriptionNextRenewalLabel: 'Next renewal',
  currentSubscriptionPeriodLabel: 'Current period',
  noSubscriptionNote: 'You’re currently not on a paid subscription. Upgrade to unlock premium features.',
  paymentMethodLabel: 'Payment method',
  paymentMethodHelp: '',
  updatingLabel: 'Updating…',
  scheduledChangeLabel: 'Scheduled change',
  scheduledDowngradePrefix: 'Switch to',
  scheduledCancellationSummary: 'Downgrade to Free scheduled at period end.',
  cancelScheduledChange: 'Keep current plan',
  scheduledChangeBlockedToast: 'A plan change is already scheduled. Cancel it before making another change.',
  scheduledChangeCancelledToast: 'Scheduled plan change cancelled.',
  cancelledSummary: 'Your subscription ended. Reactivate anytime.',

  choosePlanTitle: 'Choose your plan',
  planFreeLabel: 'Free',
  planCurrentCta: 'Current Plan',
  planSelectCta: 'Select Plan',
  planUpgradeCtaPrefix: 'Upgrade to',
  planDowngradeCtaPrefix: 'Switch to',
  planDowngradeFreeCta: 'Downgrade to Free',
  planMostPopular: 'Most Popular',
  planPerMonthSuffix: 'mo',
  planPerYearSuffix: 'yr',
  selectedLabel: 'Selected',
  amountLabel: 'Amount',
  proceedToPaymentCta: 'Proceed to payment',
  switchToFreeCta: 'Switch to Free',
  processingCta: 'Processing…',
  preparingCheckoutHint: 'Preparing checkout…',
  awaitingWebhookNote: 'Your payment is being confirmed. You can navigate away; we’ll update this automatically.',

  billingHistoryTitle: 'Billing history',
  billingHistorySubtitle: 'Download invoices and track payment status.',
  billingHistoryEmpty: 'No payments yet. Your first invoice will appear here after your subscription activates.',
  billingHistoryDateHeader: 'Date',
  billingHistoryDescriptionHeader: 'Description',
  billingHistoryAmountHeader: 'Amount',
  billingHistoryInvoiceHeader: 'Invoice',
  billingHistoryReceiptHeader: 'Receipt',
  billingHistoryStatusLabel: 'Status',
  billingHistoryFromLabel: 'From',
  billingHistoryToLabel: 'To',
  billingHistoryAll: 'All',
  billingHistoryPrev: 'Prev',
  billingHistoryNext: 'Next',
  billingHistoryPageLabel: 'Page',
  billingHistoryShowingLabel: 'Showing',
  billingHistoryOfLabel: 'of',
  billingHistoryPaymentsLabel: 'payments',

  invoiceNotAvailable: 'Invoice not yet available',
  downloadPdf: 'Download',
  receiptLabel: 'Razorpay',

  prorationModalTitle: 'Review & proceed',
  modalCancel: 'Cancel',
  modalConfirm: 'Confirm',
  modalConfirmAndPay: 'Confirm & Pay',
  prorationCurrentPlan: 'Current plan',
  prorationNewPlan: 'New plan',
  prorationChargeToday: "You’ll be charged today",
  prorationNextBillingDate: 'Next billing date',
  prorationNextCharge: 'Next charge',
  prorationDaysRemaining: 'Days remaining',
  prorationSwitchingFrom: 'Switching from',
  prorationSwitchingTo: 'to',
  prorationDaysLabel: 'days remaining',
  prorationLessCreditPrefix: 'Less:',
  prorationCreditSuffix: 'credit',
  prorationTotalDueNow: 'Total due now',
  prorationFromLabel: 'From',
  prorationOnwardsLabel: 'onwards:',
  prorationLoading: 'Loading proration preview…',
  prorationError: 'Unable to calculate proration. Please try again.',
  prorationLargeChargeWarning: 'This is a significant charge. Review carefully before confirming.',
  prorationUsageFeeNote: 'Plus ₹12 per confirmed booking, invoiced monthly in arrears.',
  prorationInvoiceNote: 'A payment receipt is emailed after each successful charge and is available under Billing history below.',
  couponCheckoutOnlyNote: 'Coupons apply during checkout flows only.',

  couponLabel: 'Coupon',
  couponPlaceholder: 'Enter coupon code',
  couponValidating: 'Validating…',
  couponInvalid: 'Invalid or expired coupon',
  couponApply: 'Apply',
  couponRemove: 'Remove',
  couponAppliedSuffix: 'applied',

  alertTitle: 'Action needed',
  errorGeneric: 'Something went wrong.',
  errorReferencePrefix: 'Something went wrong. Error reference:',
  errorCopy: 'Copy',
  supportPrefix: 'Need help?',
  supportLinkText: 'Contact support',

  paymentPendingTitle: 'Payment pending',
  paymentPendingMessage: 'Your UPI payment request has been sent. Open your UPI app and approve the request to complete activation.',
  paymentPendingCheckStatus: 'Check status',

  confirmationProcessingPayment: 'Processing payment…',
  confirmationVerifyingPayment: 'Verifying payment…',
  webhookAwaitingBanner: 'Your payment is being confirmed. This usually takes under 30 seconds.',
  webhookSuccessBanner: 'Payment confirmed. Your subscription is now active.',
  webhookTimeoutBanner: "Taking longer than expected. We'll email you once confirmed.",
  webhookFailedBanner: 'We could not confirm your payment yet. Please try again.',
  successTitle: 'Payment successful.',
  successMessage: 'Your payment is confirmed. If your plan has not updated yet, it will be reflected shortly.',
  refresh: 'Refresh',
  retryPaymentCta: 'Retry payment',
  cancelAtPeriodEnd: 'Cancel at period end',

  billingCycleMonthly: 'Monthly',
  billingCycleYearly: 'Yearly',
  billingCycleSave: 'Save',

  // C1: per-booking usage panel
  usageCurrentPeriodTitle: 'Usage this period',
  usageConfirmedLabel: 'Confirmed bookings',
  usageBillableLabel: 'Billable bookings',
  usageAccruedLabel: 'Accrued charges',
  usageNextInvoiceLabel: 'Next invoice estimate',
  usageNote: 'You’re charged only for confirmed bookings. Invoiced monthly.'
});
